"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Url_1 = require("../types/Url");
var Browser = (function () {
    function Browser() {
        this.page = new Page();
    }
    return Browser;
}());
exports.Browser = Browser;
var Page = (function () {
    function Page() {
        this.url = new Url_1.Url(document.location.href);
        if (document.referrer) {
            this.referrer = new Url_1.Url(document.referrer);
        }
    }
    return Page;
}());
//# sourceMappingURL=Browser.js.map